import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";

const EVENT_COLORS = {
  received_safe: "bg-blue-100 text-blue-700", transferred: "bg-indigo-100 text-indigo-700",
  sold: "bg-emerald-100 text-emerald-700", refunded: "bg-red-100 text-red-700",
  adjusted: "bg-amber-100 text-amber-700", prize: "bg-amber-100 text-amber-800", created: "bg-slate-100 text-slate-700",
};

export default function History() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/history").then((r) => setRows(r.data)).catch(() => {}); }, []);
  const filtered = q ? rows.filter((r) => (r.name || "").toLowerCase().includes(q.toLowerCase())) : rows;

  return (
    <div className="max-w-5xl space-y-4">
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter by product…" className="max-w-xs" data-testid="history-filter-input" />
      <Card className="divide-y">
        {filtered.map((h) => (
          <div key={h.id} className="flex items-center gap-3 p-3 text-sm" data-testid={`history-event-${h.id}`}>
            <Badge className={EVENT_COLORS[h.event] || "bg-slate-100 text-slate-700"}>{h.event}</Badge>
            <div className="flex-1"><span className="font-medium">{h.name}</span> · {Number(h.quantity).toFixed(1)}{h.source && <span className="text-xs text-slate-400"> · {h.source} → {h.destination}</span>}</div>
            <span className="text-xs text-slate-400">{h.by} · {fmtDate(h.at)}</span>
          </div>
        ))}
        {filtered.length === 0 && <div className="p-8 text-center text-slate-400 text-sm">No history yet.</div>}
      </Card>
    </div>
  );
}
